<!--
    @修改人：黎柏祺
    @修改时间：2018-12-19
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 邱凤云
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 应用日志服务页面
-->
<template>
  <div class="appServiceConfig__content">
    <div class="appServiceConfig__card mb-base">
      <ul>
        <li class="app-status-wrap"
          :class="{ rotate180: item.transitionChange,
          'status-error': item.status ==='error',
          'status-warning': item.status ==='warning',
          'default-bg': item.transitionChange}"
          @click="e_checkGroup(index, item)"
          @mouseenter="checkStatus(index)"
          @mouseleave="leaveStatus(index)"
          v-for="(item, index) in groupStatus" 
          :key="index">
          <div class="app-status-text" :class="{ rotate180: item.transitionChange }">
            <div v-if="item.textChange">
              <span v-text="item.backApp"></span>
              <span v-text="item.backNode"></span>
            </div>
            <div v-else v-text="item.front"></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="appServiceConfig__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto"> 
        <el-form-item :label="$t('logComponentManage.appName')">
          <el-input v-model="form.appName"></el-input>
        </el-form-item> 
        <el-form-item :label="$t('logComponentManage.group')">
          <g-select :list="groupList" v-model="form.group" :default-all="true" ></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.serverStatue')">
          <g-select :list="select_status" v-model="form.status" :default-all="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.ipSearch')">
          <el-input v-model="form.ip"></el-input>
        </el-form-item> 
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('appServiceConfig_search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_multiDelete()" v-g-rac="gRac('appServiceConfig_delete')">{{ $t('common.delete') }}</el-button>
          <el-button type="primary" @click="e_batchAmend()" v-g-rac="gRac('appServiceConfig_batchAmend')">{{ $t('logComponentManage.batchAmend') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :selection="true" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      :selectionChange="tSelectionChange"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <dialog-form
      key="pathForm"
      :title="dialogTitle" 
      :size="2" 
      :label-size="5" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :cancel-fun="e_cancel"
      :confirm-fun="e_save">
    </dialog-form>
    <el-dialog :closeOnClickModal="false"
      :title="$t('logComponentManage.batchAmend')"
      :visible.sync="batchAmendDiaVis"
      width="400px">
      <el-form ref="handleForm" :model="handleForm" input-width="180px" label-width="110px">
        <el-form-item :label="$t('logComponentManage.group')" prop="group">
          <g-select v-model="handleForm.group" :list="groupList"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.applyName')" prop="appName">
          <g-select v-model="handleForm.appName" :list="select_app" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.log1Level')" prop="log4jLevel">
          <g-select v-model="handleForm.log4jLevel" :list="select_log"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.logLevel')" prop="log4j2Level">
          <g-select v-model="handleForm.log4j2Level" :list="select_log"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.uploadLevel')" prop="uploadLevel">
          <g-select v-model="handleForm.uploadLevel" :list="select_log"></g-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchAmendDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" @click="batchAmendConfirm()" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>
        
<script >
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import appServiceConfigBiz from '@/logic/systemSetting/appServiceConfigBiz.js'
  import dialogForm from '@/components/dialogForm'
  import { extend, getKeyByValue } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, dic, table],
    components: {
      dialogForm
    },
    props: ['siteCode'],
    data () {
      const that = this
      return {
        form: {
          group: '',
          appName: '',
          ip: '',
          status: ''
        },
        select_bool: {
          true: that.$t('logComponentManage.yes'),
          false: that.$t('logComponentManage.no')
        },
        select_status: {
          1: that.$t('logComponentManage.online'),
          2: that.$t('logComponentManage.offline')
        },
        groupStatus: [],
        selectService: [],
        tableControl: [
          {
            label: that.$t('common.edit'),
            callback: that.e_add,
            rac: () => that.gRac('appServiceConfig_amend')
          }, {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('appServiceConfig_delete')
          }
        ],
        dialogFormShow: false,
        dialogTitle: that.$t('logComponentManage.update'),
        dialogData: [],
        dialogModel: {},
        dialogFormRule: {},
        getStatusTimer: null,
        statusTimer: null,
        select_log: {},
        init: true,
        group: {},
        groupList: {},
        batchAmendDiaVis: false,
        select_app: {},
        handleForm: {
          group: '',
          appName: '',
          log4jLevel: '',
          log4j2Level: '',
          uploadLevel: '',
          siteCode: ''
        }
      }
    },
    computed: {
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetGroup(this.siteCode, true),
          this.dGetDictionaryByCode('logLevel')
        ])
        this.groupList = this.$store.state.dicModule.group
        this.select_log = this.dDictionary.logLevel
        this.initTable()
        this.setDialogData()
        this.e_getAppStatus()
        this.getStatusTimer = setInterval(() => {
          this.e_getAppStatus()
        }, 60000)
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'logComponentManage.table',
          head: ['appName', 'group', 'ip', 'port', 'status', 'log1Level', 'logLevel', 'uploadLevel', 'registerDate', 'updateTime', 'version', 'appVersion', 'endReply'],
          requestFun: this.search,
          headOpt: {
            group: {
              formatter: 'Dictionary',
              formatterDic: this.groupList
            },
            status: {
              formatter: 'Dictionary',
              formatterDic: this.select_status
            },
            logLevel: {
              formatter: 'Dictionary',
              formatterDic: this.select_log
            },
            log1Level: {
              formatter: 'Dictionary',
              formatterDic: this.select_log
            },
            uploadLevel: {
              formatter: 'Dictionary',
              formatterDic: this.select_log
            }
          }
        })
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        reqData.siteCode = this.siteCode
        appServiceConfigBiz.getNodeInfo(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.registerDate = TimeFormat.getFormatTime(item.registerDate)
              item.updateTime = TimeFormat.getFormatTime(item.updateTime)
              item.endReply = TimeFormat.getFormatTime(item.endReply)
            })
          }
          this.tData = data
        })
      },
      async waitAppList (group) {
        await this.dGetAppByGroup(this.siteCode, group)
        this.select_app = { ...this.dDictionaryApp[group] }
        this.handleForm.appName = ''
      },
      e_batchAmend () {
        this.handleForm.group = Object.keys(this.groupList)[0]
        this.handleForm.appName = ''
        this.handleForm.log4j2Level = 'INFO'
        this.handleForm.log4jLevel = 'INFO'
        this.handleForm.uploadLevel = 'INFO'
        this.batchAmendDiaVis = true
      },
      batchAmendConfirm () {
        this.handleForm.siteCode = this.siteCode
        appServiceConfigBiz.batchAmendLog({ ...this.handleForm }).then(() => {
          this.batchAmendDiaVis = false
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.search()
        })
      },
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('logComponentManage.ip'),
            key: 'ip',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.port'),
            key: 'port',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.group'),
            key: 'group',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.appName'),
            key: 'appName',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.status'),
            key: 'status',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.registerTime'),
            key: 'registerDate',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.updateTime'),
            key: 'updateTime',
            inputWidth: '200px',
            disabled: true
          },
          {
            label: this.$t('logComponentManage.log1Level'),
            key: 'log1Level',
            inputWidth: '200px',
            type: 'select',
            select: this.select_log
          },
          {
            label: this.$t('logComponentManage.logLevel'),
            key: 'logLevel',
            inputWidth: '200px',
            type: 'select',
            select: this.select_log
          },
          {
            label: this.$t('logComponentManage.uploadLevel'),
            key: 'uploadLevel',
            inputWidth: '200px',
            type: 'select',
            select: this.select_log
          },
          {
            label: this.$t('logComponentManage.controllerResTime'),
            key: 'controllerResTime',
            inputWidth: '200px',
            type: 'number',
            placeholder: this.$t('logComponentManage.ms')
          },
          {
            label: this.$t('logComponentManage.serviceResTime'),
            key: 'serviceResTime',
            inputWidth: '200px',
            type: 'number',
            placeholder: this.$t('logComponentManage.ms')
          },
          {
            label: this.$t('logComponentManage.daoResTime'),
            key: 'daoResTime',
            inputWidth: '200px',
            type: 'number',
            placeholder: this.$t('logComponentManage.ms')
          },
          {
            label: this.$t('logComponentManage.isOpen'),
            key: 'open',
            inputWidth: '200px',
            type: 'radio',
            select: this.select_bool
          },
          {
            label: this.$t('logComponentManage.uploadLog1'),
            key: 'uploadLog1',
            inputWidth: '200px',
            type: 'radio',
            select: this.select_bool
          },
          {
            label: this.$t('logComponentManage.uploadControl'),
            key: 'uploadControl',
            inputWidth: '200px',
            type: 'radio',
            select: this.select_bool
          }
        ]
        const validatePass = (rule, value, callback) => {
          if (value % 1 !== 0) {
            callback(new Error(this.$t('logComponentManage.numberTips')))
          } else {
            callback()
          }
        }
        this.dialogFormRule = {
          controllerResTime: [{
            validator: validatePass, trigger: 'blur'
          }],
          serviceResTime: [{
            validator: validatePass, trigger: 'blur'
          }],
          daoResTime: [{
            validator: validatePass, trigger: 'blur'
          }]
        }
      },
      e_getAppStatus () {
        appServiceConfigBiz.getNodeGroup({siteCode: this.siteCode}).then((d) => {
          this.groupStatus = []
          d.map((item) => {
            let obj = {}
            let sumApp = Number(item.offline) + Number(item.online)
            let inlineNode = Number(item.nodeCount) - Number(item.offlineNode)
            let status = ''
            if (item.offline >= 1) {
              status = 'error'
            } else if (item.offlineNode > 0) {
              status = 'warning'
            } else {
              status = 'normal'
            }
            obj.front = item.group
            obj.backApp = 'APP : ' + item.offline + '/' + sumApp
            obj.backNode = 'NODE : ' + inlineNode + '/' + item.nodeCount
            obj.transitionChange = false
            obj.textChange = false
            obj.status = status
            this.groupStatus.push(obj)
          })
        })
      },
      e_checkGroup (index, item) {
        this.leaveStatus(index)
        this.form.group = item.front
        this.$nextTick(() => {
          this.e_search()
        })
      },
      checkStatus (i) {
        this.groupStatus[i].transitionChange = true
        this.clearStatus(i)
        this.statusTimer = setTimeout(() => {
          this.groupStatus.map((item) => {
            item.textChange = false
          })
          this.groupStatus[i].textChange = true
        }, 300)
      },
      leaveStatus (i) {
        this.groupStatus[i].transitionChange = false
        this.clearStatus(i)
        this.statusTimer = setTimeout(() => {
          this.groupStatus.map((item) => {
            item.textChange = false
          })
        }, 300)
      },
      clearStatus (i) {
        clearTimeout(this.statusTimer)
        this.statusTimer = null
      },
      tSelectionChange (data) {
        this.selectService = data
      },
      e_multiDelete () {
        if (this.selectService.length === 0) {
          this.$message({
            message: this.$t('logComponentManage.unSelected'),
            type: 'warning'
          })
          return
        }
        let data = []
        this.selectService.map((item) => {
          data.push(item.id)
        })
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          appServiceConfigBiz.deleteMulService({batchId: data}).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {
  
        })
      },
      e_add (rowData) {
        this.dialogFormShow = true
        this.dialogModel = {
          ip: rowData.ip,
          port: rowData.port,
          appName: rowData.appName,
          group: rowData.group,
          status: rowData.status,
          registerDate: rowData.registerDate,
          updateTime: rowData.updateTime,
          log1Level: rowData.log1Level,
          logLevel: rowData.logLevel,
          uploadLevel: rowData.uploadLevel,
          controllerResTime: rowData.controllerResTime,
          serviceResTime: rowData.serviceResTime,
          daoResTime: rowData.daoResTime,
          uploadControl: rowData.uploadControl ? 'true' : 'false',
          uploadLog1: rowData.uploadLog1 ? 'true' : 'false',
          open: rowData.open ? 'true' : 'false',
          id: rowData.id
        }
      },
      e_cancel () {
        this.dialogFormShow = false
      },
      e_save (d) {
        const data = {
          ip: this.dialogModel.ip,
          port: this.dialogModel.port,
          logLevel: getKeyByValue(this.select_log, this.dialogModel.logLevel),
          uploadLevel: getKeyByValue(this.select_log, this.dialogModel.uploadLevel),
          controllerResTime: this.dialogModel.controllerResTime,
          serviceResTime: this.dialogModel.serviceResTime,
          daoResTime: this.dialogModel.daoResTime,
          isOpen: this.dialogModel.open === 'true',
          log1Level: getKeyByValue(this.select_log, this.dialogModel.log1Level),
          uploadLog1: this.dialogModel.uploadLog1 === 'true',
          uploadControl: this.dialogModel.uploadControl === 'true',
          siteCode: this.siteCode
        }
        let params = new URLSearchParams()
        Object.keys(data).map((item) => {
          params.append(item, data[item])
        })
        appServiceConfigBiz.updateService(params).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            this.dialogFormShow = false
            this.e_search()
          }, 500)
        })
      },
      e_delete (rowData) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          appServiceConfigBiz.deleteService({id: rowData.id}).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {
  
        })
      }
    },
    mounted () {
      if (Object.keys(this.$route.query).length !== 0) {
        this.form.group = this.$route.query.group
      }
    },
    watch: {
      '$route' (newV, oldV) {
        if (newV.name === 'logComponentManage') {
          this.getStatusTimer = setInterval(() => {
            this.e_getAppStatus()
          }, 60000)
        }
        if (oldV.name === 'logComponentManage') {
          clearInterval(this.getStatusTimer)
        }
        if (newV.name === 'logComponentManage' && oldV.name === 'alarmTrend' && Object.keys(newV.query).length !== 0) {
          this.form.group = newV.query.group
          this.search()
        }
      },
      'siteCode' () {
        if (this.init) {
          this.init = false
          this.preInitTable()
          this.e_search()
        } else {
          this.e_getAppStatus()
          this.e_search()
        }
      },
      'handleForm.group' () {
        this.waitAppList(this.handleForm.group)
      }
    }
  }
</script>

<style scoped>
  .appServiceConfig__content .app-status-wrap {
    width: 200px;
    height: 40px;
    background: #3bdd9e;
    transition: background .9s, transform .9s;
    margin: 4px;
    color: #fff;
    border-radius: 2px;
    font-size: 12px;
    display: inline-block;
  }
  .appServiceConfig__content .app-status-text {
    color: #fff;
    height: 40px;
    line-height: 40px;
    transition: transform .9s;
    text-align: center;
    cursor: pointer;
  }
  .appServiceConfig__content .app-status-text span {
    padding: 4px;
  }
  .appServiceConfig__content .rotate180 {
    transform: rotateX(180deg);
  }
  .appServiceConfig__content .status-error {
    background: #fc7d70;
  }
  .appServiceConfig__content .status-warning {
    background: #f5b033;
  }
  .appServiceConfig__content .default-bg {
    background: #8192a5;
  }
  .appServiceConfig__site .appServiceConfig__siteName {
    font-weight: 700;
    font-size: 16px;
    padding: 0 10px;
  }
  .appServiceConfig__site .appServiceConfig__siteSelect {
    width: 200px;
  }
</style>
        
        
        
        
        
        
        